import React from 'react'
import moment from 'moment'
import { IColumnDimension } from './calendarTypes'
import DayComment from './DayComment'

export interface ICalendarDayComment {
  date: Date
  comment: string
}

interface IProps {
  firstDay: moment.Moment
  numberOfDays: number
  columnDimensions: IColumnDimension[]
  comments: ICalendarDayComment[]
  height: number
  fontSize: string
  onChange?(date: Date, value: string): void
}

const CalendarDayComments: React.FC<IProps> = ({
  firstDay,
  numberOfDays,
  columnDimensions,
  comments,
  height,
  fontSize,
  onChange,
}) => {
  if (columnDimensions.length === 0) {
    return null
  }

  let totalWidth = 0

  const weekdayColumns = Array.from(Array(numberOfDays).keys()).map(
    (_key: unknown, index: number): React.ReactNode => {
      const { width } = columnDimensions[index]
      totalWidth += width
      const date = moment(firstDay).add(index, 'd')
      const comment = comments.find((comment) =>
        moment(comment.date).isSame(date, 'day'),
      )

      return (
        <DayComment
          key={index}
          firstDay={firstDay}
          comment={comment?.comment}
          width={width}
          height={height}
          fontSize={fontSize}
          isEditing={!!onChange}
          onChange={(value) => onChange(date.toDate(), value)}
        />
      )
    },
  )

  return (
    <div
      className="weekCalendar__headerWrapper"
      style={{
        width: totalWidth,
        backgroundColor: '#FFFFFF',
      }}
    >
      {weekdayColumns}
    </div>
  )
}

export default CalendarDayComments
